/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_ValidatorInputs */

const en_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a number greater than or equal to 0`)
};

const fr_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir un nombre supérieur ou égal à 0`)
};

const de_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine Zahl größer oder gleich 0 ein`)
};

const it_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numero maggiore o uguale a 0`)
};

const ru_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите число больше или равное 0`)
};

const es_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un número mayor o igual a 0`)
};

const zh_cn2_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入大于或等于0的数字`)
};

const ja_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0以上の数値を入力してください`)
};

const hi_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया 0 या उससे अधिक संख्या दर्ज करें`)
};

const pt_pt2_ad_template_min_gap_validator = /** @type {(inputs: Ad_Template_Min_Gap_ValidatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um número maior ou igual a 0`)
};

/**
* | output |
* | --- |
* | "Please enter a number greater than or equal to 0" |
*
* @param {Ad_Template_Min_Gap_ValidatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_validator = /** @type {((inputs?: Ad_Template_Min_Gap_ValidatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_ValidatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_min_gap_validator(inputs)
	if (locale === "de") return de_ad_template_min_gap_validator(inputs)
	if (locale === "it") return it_ad_template_min_gap_validator(inputs)
	if (locale === "ru") return ru_ad_template_min_gap_validator(inputs)
	if (locale === "es") return es_ad_template_min_gap_validator(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_min_gap_validator(inputs)
	if (locale === "ja") return ja_ad_template_min_gap_validator(inputs)
	if (locale === "hi") return hi_ad_template_min_gap_validator(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_min_gap_validator(inputs)
	return en_ad_template_min_gap_validator(inputs)
});